'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  text-transform: uppercase;\n  box-shadow: 0 2px 12px ', ';\n\n  &:hover,\n  &:focus {\n    box-shadow: 0 2px 12px 2px\n      ', ';\n  }\n\n  &:active {\n    box-shadow: 0 4px 16px 2px\n      ', ';\n  }\n'], ['\n  text-transform: uppercase;\n  box-shadow: 0 2px 12px ', ';\n\n  &:hover,\n  &:focus {\n    box-shadow: 0 2px 12px 2px\n      ', ';\n  }\n\n  &:active {\n    box-shadow: 0 4px 16px 2px\n      ', ';\n  }\n']);

var _Button = require('./Button');

var _Button2 = _interopRequireDefault(_Button);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LargeButton = _Button2.default.extend(_templateObject, function (_ref) {
  var theme = _ref.theme;
  return theme.shadowColor;
}, function (props) {
  return props.inverted ? props.theme.shadowColor : (0, _theme.hexa)(props.bg, 0.25);
}, function (props) {
  return props.inverted ? props.theme.shadowColor : (0, _theme.hexa)(props.bg, 0.25);
});

LargeButton.displayName = 'LargeButton';

LargeButton.defaultProps = {
  theme: _theme2.default,
  bg: 'primary',
  color: 'white',
  fontSize: 3,
  m: 0,
  py: 3,
  px: 4
};

LargeButton.button = LargeButton.withComponent('button');
LargeButton.input = LargeButton.withComponent('input');

exports.default = LargeButton;